const E = {
  'Submit a Job': 'Submit a Job',
  Error1: 'You can not submit your submission without samples',
  Error2:
    'More Values are not complete for samples provided, please update before submitting.',
  Error3:
    'You do not have enough composite bottles, Please select more than one bottle.',
  Error4:
    'You have missing bottles in samples, Please select more than one bottle.',
  Error5:
    'Sampling dates cannot be in the future, please update before submitting.',
  Error6:
    'Each sample should have at least one test, please add test or remove sample',
  Error7: 'Testing date should not be in the past',
  Error8: 'Production date must be in the past',
  Error9: 'Sampling dates are not complete.',
  Error10:
    'ETA at the Lab cannot be in the past, please update before submitting.',
  Error11:
    'ETA at the Lab has not been entered, please update before submitting.',
  Error12:
    'Shipping method has not been entered, please update before submitting.',
  Error13: 'Sample IDs are limited to 200 characters',
  Error14: 'Samples may not share the same ID, date, and time',
  Error15: 'Samples must have a Matrix',
  Error16: 'Samples must have at least 1 Test',
  Error17: 'Samples must have a Sample ID',
  Error18: 'Days must be in ascending order',
  Error19: 'Criteria 1 is not complete',
  Error20: 'ETA is prior to sampling date',
  Error21: 'This Submission contains future sampling dates',
  ProjectInfo: 'Project Information:',
  ReportTo: 'Report To:',
  InvoiceTo: 'Invoice To',
  'PO/AFE #': 'PO/AFE #',
  'Project #': 'Project #',
  'Site Location': 'Site Location',
  'Site #': 'Site #',
  'Task Order': 'Task Order',
  'Line Item': 'Line Item',
  'Cost Object': 'Cost Object',
  Shipping: 'Shipping',
  'Results Required By': 'Results Required By:',
  OrderRequiredBy: 'Order Required By:',
  'Destination Lab': 'Destination Lab',
  ServiceLevel: 'Service Level:',
    TaxStatement: 'Hold, disposal, taxes, and surcharges are not included.',
  EstimatedPrice: 'Estimated Price:',
  Details: 'Details',
  Criteria1: 'Criteria 1',
  Criteria2: 'Criteria 2',
  ShelfLife: 'Storage Condition',
  OnCofA: 'On CofA',
  Yes: 'Yes',
  No: 'No',
  'Waterworks Information': 'Waterworks Information',
  'Waterworks #': 'Waterworks #',
  WaterworksName: 'Waterworks Name',
  Contact: 'Contact:',
  Phone: 'Phone:',
  Fax: 'Fax:',
  Cell: 'Cell:',
  Email: 'Email:',
  Title2: 'Medical Officer of Health/Public Health Unit',
  NameRegion: 'Name/Region:',
  'After Hours Phone': 'After Hours Phone:',
  SampleID: 'Sample ID',
  Matrix: 'Matrix',
  Bottles: 'Bottles',
  MoreValues: 'More Values',
  SampledOn: 'Sampled On',
  Comments: 'Comments',
  TestingDate: 'Testing Date',
  'Repeat Order On': 'Repeat Order On',
  'Repeat Order Schedule': 'Repeat Order Schedule',
  Samples: 'Samples:',
  'Required Value Missing': 'Required Value Missing',
  Hold: 'Hold',
  'Job Details': 'Job Details',
  Parameters: 'Parameters',
  'Job Files': 'Job Files',
  Observations: 'Observations',
  'eCOC Documents': 'eCOC Documents',
  regularSamplesHeader: 'Regular Samples:',
  qcSamples: 'QC Samples:',
  printedLabels: 'Printed Labels: ',
  supplies: 'Supplies:',
  hasEmptyOrder: 'Please select at least one Sample or QC item.',

  NoFullDate: 'Please enter both a Date and Time',
  NoValidDate: 'Please Enter a Valid Date',
  NoFutureDate: 'Please Enter a Date in the Future',
  ShippingTime24HoursFromNow:
    'Shipping Time Must be at Least 24 Hours from Now',
  NoShipDateOnWeekDay: 'Required By date cannot fall on a weekend or holiday.',
  OrderExist: 'Order Date Already Exists',
  NoRepeateOrderOnHoliday:
    'Repeat Order Date should not be a holiday for the Bureau Veritas location you have selected',
  NoRepeateOrder24hrs: 'There must be 24 hrs between orders.',
  recommendSuppliesHeader:
    'Based on the supplies you selected you may also want to consider ordering: ',
  recommendAdditionalSuppliesHeader: 'Recommended Additional Supplies',
};

const F = {
  hasEmptyOrder:
    'Veuillez sélectionner au moins un échantillon ou un élément de CQ.',
  NoRepeateOrder24hrs: 'Il doit y avoir 24 heures entre les commandes.',

  NoFullDate: "S'il vous plaît entrer une date complète",
  NoValidDate: "S'il vous plaît entrer une date valide",
  NoFutureDate: "S'il vous plaît entrer une date dans le futur",
  ShippingTime24HoursFromNow:
    'Le délai de livraison doit être inférieur à 24 heures à compter de maintenant',
  NoShipDateOnWeekDay:
    'La date dans le champ Requis pour le ne peut pas être un jour de fin de semaine ni un jour férié.',
  OrderExist: 'La date de commande existe déjà',
  NoRepeateOrderOnHoliday:
    "La date de commande répétée ne doit pas être un jour férié à l'emplacement Bureau Veritas que vous avez sélectionné",

  supplies: 'Matériel :',
  qcSamples: 'Échantillons de CQ :',
  printedLabels: 'Étiquettes imprimées :',
  'Submit a Job': 'Envoyer un dossier',
  regularSamplesHeader: 'Échantillons réguliers :',
  Error1: 'Vous ne pouvez pas envoyer votre dossier sans échantillons.',
  Error2:
    'Plusieurs valeurs manquantes pour les échantillons ajoutés, veuillez remplir les champs requis avant de procéder à l’envoi.',
  Error3:
    'Il manque des contenants pour les composites. Il faut en choisir plus d’un.',
  Error4:
    'Il manque des contenants pour vos échantillons. Il faut en choisir plus d’un.',
  Error5: 'La date d’échantillonnage ne doit pas dépasser celle d’aujourd’hui.',
  Error6:
    'Au moins une analyse doit être choisie pour chaque échantillon, veuillez en ajouter une ou enlever un échantillon.',
  Error7: 'La date d’analyse doit dépasser celle d’aujourd’hui.',
  Error8: 'La date de production doit être antérieure à celle d’aujourd’hui.',
  Error9: 'Les dates d’échantillonnage ne sont pas complètes.',
  Error10: 'L\'ETA au laboratoire ne peut pas être dans le passé, veuillez mettre à jour avant de soumettre.',
  Error11: 'L\'ETA au laboratoire n\'a pas été entré, veuillez mettre à jour avant de soumettre.',
  Error12: 'La méthode d\'expédition n\'a pas été entrée, veuillez mettre à jour avant de soumettre.',
  Error13: "Les ID d'échantillons sont limités à 200 caractères",
  Error14:
    "Les échantillons peuvent ne pas partager le même identifiant, la même date et l'heure",
  Error15: 'Les échantillons doivent avoir une matrice',
  Error16: 'Les échantillons doivent avoir au moins 1 test',
  Error17: 'Les échantillons doivent avoir un ID d’échantillon',
  Error18: "Les jours doivent être dans l'ordre croissant",
  Error19: "Le critère 1 n'est pas complet",
  Error20: "L'ETA est avant la date d’échantillonnage",
  Error21: "Cette soumission contient des dates d'échantillonnage futures",
  ProjectInfo: 'Renseignements sur le projet :',
  ReportTo: 'Envoyer le rapport à :',
  OrderRequiredBy: 'Commande requise pour le :',
  InvoiceTo: 'Envoyer la facture à',
  'PO/AFE #': 'No de PO ou d’AFE',
  'Project #': 'No de projet',
  'Site Location': 'Emplacement du site',
  'Site #': 'No de site',
  'Task Order': 'No d’engagement',
  'Line Item': 'No de ligne',
  'Cost Object': 'Objet de coût',
  Shipping: 'Envoi',
  'Results Required By': 'Résultats requis pour le :',
  'Destination Lab': 'Destination (laboratoire) :',
  ServiceLevel: 'Délai requis :',
    TaxStatement: 'Les frais d’échantillons sans analyse, frais de gestion, taxes et surcharges ne sont pas inclus.',
  EstimatedPrice: 'Coût approximatif :',
  Details: 'Détails',
  ShelfLife: 'Conditions d’entreposage',
  Criteria1: 'Critère 1',
  Criteria2: 'Critère 2',
  OnCofA: 'Sur le certificat d’analyse',
  Yes: 'Oui',
  No: 'Non',
  'Waterworks Information': 'Information sur l’aqueduc',
  'Waterworks #': 'No d’aqueduc',
  WaterworksName: 'Nom de l’aqueduc:',
  Contact: 'Contact :',
  Phone: 'Téléphone :',
  Fax: 'Télécopieur :',
  Cell: 'Cellulaire :',
  Email: 'Adresse courriel :',
  Title2: 'Médecin hygiéniste ou bureau de santé publique',
  NameRegion: 'Nom ou région :',
  'After Hours Phone': 'Téléphone après les heures normales :',
  SampleID: 'ID de l’échantillon',
  Matrix: 'Matrice',
  Bottles: 'Contenants',
  SampledOn: 'Échantillonné le',
  MoreValues: 'Afficher plus de valeurs :',
  Comments: 'Commentaires',
  'Repeat Order On': 'Répéter la commande le',
  'Repeat Order Schedule': 'Répéter le calendrier de commande',
  Samples: 'Échantillons:',
  'Required Value Missing': 'Valeur requise manquante',
  Hold: 'Mettre en attente',
  TestingDate: 'Date de l’analyse',
  'Job Details': 'Détails sur le dossier',
  Parameters: 'Paramètres',
  'Job Files': 'Fichiers d’analyse',
  Observations: 'Observations',
  'eCOC Documents': 'Documents joints à l’eCDR',
  recommendSuppliesHeader:
    'En fonction du matériel que vous avez sélectionné, vous pourriez aussi commander :',
  recommendAdditionalSuppliesHeader: 'Matériel additionnel suggéré',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/formsSummary.js